import React, { useState } from 'react';
import ReactDOM from "react-dom";
import { axiosInstance } from '../utils';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AdminModal = ({cancel}) => {
  const [registerAdmin, setRegisterAdmin] = useState({
    firstname: "",
    lastname: "",
    email: "",
    userId: "",
    contact: "",
    password: ""
  })

  const handleRegisterAdminChange = (e) => {
    const { name, value } = e.target;
    setRegisterAdmin(prevValues => ({...prevValues, [name]: value}))
  } 

  const handleFirstNameChange = (e) => {
    const value = e.target.value;
    const regex = /^[a-zA-Z\s]+$/;
    if (value.match(regex) || value === "") {
      setRegisterAdmin(prevValues => ({
        ...prevValues,
        firstname: value
      }))  
    }
  }

  const handleLastNameChange = (e) => {
    const value = e.target.value;
    const regex = /^[a-zA-Z\s]+$/;
    if (value.match(regex) || value === "") {
      setRegisterAdmin(prevValues => ({
        ...prevValues,
        lastname: value
      }))  
    }
  }

  const handleContactChange = (e) => {
    const value = e.target.value;
    const regex = /^[0-9]+$/;
    if (value.match(regex) || value === "") {
      setRegisterAdmin(prevValues => ({
        ...prevValues,
        contact: value
      }))  
    }
  }

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    const regex = /^[a-zA-Z0-9(\$*@)]+$/;
    if (value.match(regex) || value === "") {
      setRegisterAdmin(prevValues => ({
        ...prevValues,
        password: value
      }))  
    }
  }

  const handleEmailChange = (e) => {
    const value = e.target.value;
    const regex = /^[a-zA-Z0-9(\.@)]+$/;
    if (value.match(regex) || value === "") {
      setRegisterAdmin(prevValues => ({
        ...prevValues,
        email: value
      }))  
    }
  }


  const handleUserIdChange = (e) => {
    const value = e.target.value;
    const regex = /^[a-z0-9]+$/;
    if (value.match(regex) || value === "") {
      setRegisterAdmin(prevValues => ({
        ...prevValues,
        userId: value
      }))  
    }
  }
  
    const token = localStorage?.getItem("token");

 const handleAddNewAdmin = async (e) => {
  const { firstname, lastname, email, userId, password, contact } = registerAdmin;

   if(!firstname) {
    toast.error("Please, Enter Your First Name",
    {
      position: "top-right",
      autoClose: 5000,
      theme: "light",
      hideProgressBar: true,
    }
  );
   } else if(!lastname) {
    toast.error("Please, Enter Your Last Name",
        {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          hideProgressBar: true,
        }
      );
   } else if(!email){
    toast.error("Please, Enter Your Email",
        {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          hideProgressBar: true,
        }
      );
   } else if(!userId) {
    toast.error("Please, Enter User ID",
        {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          hideProgressBar: true,
        }
      );
   } else if(!contact) {
    toast.error("Please, Enter Your Contact Number",
        {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          hideProgressBar: true,
        }
      );
   } else if(!password) {
    toast.error("Please, Enter Password",
        {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          hideProgressBar: true,
        }
      );
   } else if(!firstname && !lastname && !email && !contact && !userId && !password) {
    toast.error("Please, Fill Out Fields",
        {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
          hideProgressBar: true,
        }
      );
   } else {

  e.preventDefault();
  let data = {
    firstName: registerAdmin.firstname,
    lastName: registerAdmin.lastname,
    email: registerAdmin.email,
    userId: registerAdmin.userId,
    contactNumber: registerAdmin.contact,
    password: registerAdmin.password
  }
  await axiosInstance.post("/api/admin/register-dashboard-user", data, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then(res => {
    toast.success(res.data.message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      });
  })
  .catch(err => { 
    toast.error(err.response.data.message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      });
  } )
}
 } 
  
 const isSmallScreen = () => window.innerWidth <= 768;

  return ReactDOM.createPortal(  <div
    className="fixed inset-0 flex items-center justify-center overflow-hidden rounded-md"
  >
    <div className="fixed inset-0 z-10 overflow-hidden bg-black opacity-50"></div>
    <div className="fixed top-0 left-0 z-20 flex h-full w-full items-center justify-center">
      <div className="relative max-h-[90vh] max-w-[90vw] rounded-lg bg-white p-6 sm:max-w-[80vw]">
        <div className='p-2'>
          <h1 className='heading-one !text-center !pb-3'>Add New Admin</h1>
         <div className={`lg:overflow-hidden md:overflow-y-scroll sm:overflow-y-scroll overflow-y-scroll lg:max-h-min md:max-h-[90vh] sm:max-h-[90vh] max-h-[90vh] `}>
          <div className='lg:space-y-3 md:space-y-2 sm:space-y-2 space-y-2'>
            <div className='flex gap-2 lg:flex-row md:flex-col sm:flex-col flex-col'>
              <div className='flex flex-col gap-1'>
                <label htmlFor='firstname' className='font-poopins text-sm font-medium text-secondary-n-200'>First Name</label>
                <input type='text' name='firstname' value={registerAdmin.firstname} onChange={handleFirstNameChange} placeholder='First Name' className='outline-none pl-3 rounded-md lg:w-[250px] md:w-full sm:w-full w-full h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm' />
              </div>
              <div className='flex flex-col gap-1'>
                <label htmlFor='lastname' className='font-poopins text-sm font-medium text-secondary-n-200'>Last Name</label>
                <input type='text' name='lastname' value={registerAdmin.lastname} onChange={handleLastNameChange} placeholder='Last Name' className='outline-none pl-3 rounded-md lg:w-[250px] md:w-full sm:w-full w-full h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm' />
              </div>
            </div>
            <div className='flex flex-col gap-1'>
                <label htmlFor='email' className='font-poopins text-sm font-medium text-secondary-n-200'>Email</label>
                <input type='email' name='email' value={registerAdmin.email} onChange={handleEmailChange} placeholder='Email' className='outline-none pl-3 rounded-md w-full h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm' />
              </div>
              <div className='flex flex-col gap-1'>
                <label htmlFor='userid' className='font-poopins text-sm font-medium text-secondary-n-200'>User ID</label>
                <input type='text' name='userId' value={registerAdmin.userId} onChange={handleUserIdChange} placeholder='User ID' className='outline-none pl-3 rounded-md w-full h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm' />
              </div>
              <div className='flex flex-col gap-1'>
                <label htmlFor='contact number' className='font-poopins text-sm font-medium text-secondary-n-200'>Contact Number</label>
                <input type='tel' name='contact' value={registerAdmin.contact} onChange={handleContactChange} minLength={11} maxLength={11} placeholder='Enter your Number' className='outline-none pl-3 rounded-md w-full h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm' />
              </div>
              <div className='flex flex-col gap-1'>
                <label htmlFor='password' className='font-poopins text-sm font-medium text-secondary-n-200'>Password</label>
                <input type='password' name='password' value={registerAdmin.password} onChange={handlePasswordChange} placeholder='Enter your Password' className='outline-none pl-3 rounded-md w-full h-10 border-[1px] border-secondary-n-50 text-secondary-n-90 font-poppins font-normal text-sm placeholder:font-poppins placeholder:text-secondary-n-90 placeholder:font-normal placeholder:text-sm' />
              </div>
              <div className='flex items-center gap-2'>
                <button className='font-poppins h-10 w-[250px] text-secondary-n-90 outline-none bg-white border-[1px] border-secondary-n-90 flex justify-center items-center rounded-md' onClick={cancel}>Cancel</button>
                <button className='font-poppins h-10 w-[250px] text-white outline-none bg-primary-yellow-500 flex justify-center items-center rounded-md' onClick={handleAddNewAdmin}>Add</button>
              </div>
          </div>
         </div>
          <ToastContainer />
        </div>
      </div>
    </div>
  </div>, document.body)
}

export default AdminModal